import { snakeCaseKeys } from "./text";

export type BaseAPIRequest = {
  authenticityToken: string;
  journeyToken: string;
} & Record<string, unknown>;

const OPTIONS = {
  method: "POST",
  headers: {
    Accept: "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8",
  },
};

export const apiRequest = async (
  url: string,
  payload: BaseAPIRequest,
): Promise<unknown> => {
  const snakeCaseBody = snakeCaseKeys(payload);
  const body = JSON.stringify(snakeCaseBody);
  const headers = {
    ...OPTIONS.headers,
    "X-CSRF-Token": payload.authenticityToken ?? "not-provided",
  };

  const response = await fetch(url, { ...OPTIONS, headers, body });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json() as Promise<unknown>;
};
